(() => {
  const banner = document.querySelector('[data-early-access]');
  if (!banner) return;
  const storageKey = 'tbtt-early-access-closed:' + banner.dataset.campaign;
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}
  const spacer = document.createElement('div');
  spacer.className = 'tbtt-early-access-spacer';
  banner.before(spacer);
  const resize = () => spacer.style.setProperty('--tbtt-early-height', banner.hidden ? '0px' : `${banner.offsetHeight}px`);
  const refresh = () => {
    banner.hidden = dismissed || banner.dataset.enabled !== 'true';
    resize();
  };
  banner.querySelector('button').addEventListener('click', () => {
    dismissed = true;
    try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
    refresh();
  });
  new ResizeObserver(resize).observe(banner);
  window.addEventListener('pageshow', refresh);
  refresh();
})();
